import { getJourneys } from "../../api/axios"
import { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import LoadingContainer from "../../components/LoadingContainer";
import { getBrandClassName } from "../../utilities/Utils";



const JourneysTable = (props) => {

const [isLoading, setIsLoading] = useState(true);
const [journeys, setJourneys] = useState([]);

// https://www.robinwieruch.de/react-hooks-fetch-data/

const { auth } = useAuth();

useEffect(() => {

  const fetchData = async () => {
      
    setIsLoading(true);
    
    try {
      
      const data = await getJourneys({props, auth});
      setJourneys(data.results);
      
    } catch (error) {

      setJourneys(null);

    }

    setIsLoading(false);

  };



  fetchData();
    
}, [props, auth]);

  

  const hasJourneys = Array.isArray(journeys) && journeys.length > 0;

  return (

    <LoadingContainer isLoading={isLoading}>
          
      <table className="table table--enhanced">
                      
        <thead>
            <tr>
                <td>ID / Marca</td>
                <td>Nombre</td> 
                <td>Piezas</td> 
            </tr>
        </thead>
        <tbody>
            {!isLoading && !hasJourneys && (
              <tr><td colSpan="3" className="c loading">No se encontraron journeys</td></tr>
            )}
            {!isLoading && hasJourneys && journeys.map( item => (

              <tr key={item.id}>
                  
                  <td>
                    <div className="table-identity">
                    <span className="table-id-pill">{item.id}</span>
                    <span className={getBrandClassName(item.brand_name, 'table-brand-label')}>{item.brand_name}</span>
                    </div>
                  </td>
                  
                  <td>
                    <span className="table-primary">{item.name}</span>
                  </td>
                  
                  <td className="c">
                    <span className="table-metric">
                      <strong>{item.cantidad}</strong>
                      <span>piezas</span>
                    </span>
                  </td>
                  
              </tr>
            ))}
            
        </tbody>

      </table>
    </LoadingContainer>
    
    )
}

export default JourneysTable
